import axios from 'axios';
import { ComponentComponentsQuestion, Maybe } from '../types/schema.d';
import { FormData } from './mastra';
import logging from './logging';
import { QuestionAnswerContext } from '../views/FormView/types';

export const generatePromptQuestions = async (
  promptQuestion: string,
  sectionId: string,
  questionsAndAnswers: QuestionAnswerContext[] = [],
  form?: FormData,
  promptCommon?: string | null,
): Promise<Maybe<ComponentComponentsQuestion>[]> => {
  try {
    const { data } = await axios.post<{ questions: Maybe<ComponentComponentsQuestion>[] }>(
      '/api/generatePromptQuestions',
      { promptQuestion, sectionId, questionsAndAnswers, form, promptCommon },
      { timeout: 150000 },
    );

    return data.questions;
  } catch (error) {
    logging.error('Error generating prompt questions', error as Error);
    const message =
      (error as { response?: { data?: { error?: string } }; message?: string })?.response?.data
        ?.error ||
      (error as Error).message ||
      'Failed to load prompt questions';
    throw new Error(message);
  }
};
